<div class="container-fluid">
  <div class="row no-gutter">
    <div class="col-md-3 d-none d-md-flex bg-image">
      <div class="container"></div>
    </div>
    <div class="col-md-6">
      <div class="login d-flex align-items-center py-5">
        <div class="container">
          <img src="assets/top2.png" class="img resptilt" />
          <div class="row">
            <img
              src="../../../assets/logo.png"
              style="width:275px;margin: auto;"
            />
          </div>
          <div class="row">
            <div class="col-lg-7 col-xl-6 mx-auto">
              <div
                class="text-danger text-center mb-3"
                style="border:1px solid #efefef"
              >
                <!-- <h5 style="margin-top: 5px;"></h5> -->
              </div>

              <!-- <h3 class="display-4">LOGIN!!</h3> -->
              <br />

              <form [formGroup]="loginForm" (ngSubmit)="onClickLogin()">
              <div class="form-group mb-1">
                <input
                  id="inputEmail"
                  type="email"
                  placeholder="Phone"
                  formControlName="phone"
                  autofocus=""
                  class="form-control rounded-pill border-0 shadow-sm px-4"
                />
              </div>
              <!-- <div class="form-group mb-3">
                <input
                  id="inputPassword"
                  type="password"
                  placeholder="Password"
                  formControlName="password"
                  class="form-control rounded-pill border-0 shadow-sm px-4 text-danger"
                /><br />
              </div> -->
              <div class="custom-control custom-checkbox mb-3">
                <input
                  id="customCheck1"
                  type="checkbox"
                  checked
                  class="custom-control-input"
                />
              </div>
              <button
              
                type="submit"
                class="btn btn-danger btn-block text-uppercase mb-2 rounded-pill shadow-sm"
              >
                Send Otp
              </button>
              <div class="text-center" style="margin-top: 1rem">
                <p>OR</p>
                <p>
                  <a style="cursor: pointer" routerLink="/patsignup">
                    <button
                      class="btn btn-primary btn-block text-uppercase mb-2 rounded-pill shadow-sm">
                      Sign Up
                    </button></a
                  >
                </p>
              </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 d-none d-md-flex bg-white"></div>
  </div>
</div>
